import { createLogger } from "browser-bunyan";
let splunkBunyan = require("splunk-bunyan-logger");

const config = {
  token: process.env.REACT_APP_SPLUNK_TOKEN || '',
  url: process.env.REACT_APP_SPLUNK_URL || '',
  port: process.env.REACT_APP_SPLUNK_PORT || 443
};

const splunkStream = splunkBunyan.createStream(config);

const splunkLogger = createLogger({
  name: "Splunk Logger",
  streams: [splunkStream]
});

export default splunkLogger; 
